// this function remembers the result from the first time it is called
// subsequent invocations ignore the function and just return the first result
// this differs from traditional memoisation because arguments are ignored too

function callOnce(op) {
    let storedValue = null;

    return function (...args) {
        if (storedValue === null) {
            storedValue = op(...args);
        }
        return storedValue;
    };
}

export default callOnce;
